import React, { Fragment, Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import _ from "lodash";
import { withModulesManager, journalize, coreConfirm, Searcher, formatMessage } from "@openimis/fe-core";
import AccreditationFilter from "./AccreditationFilter";
import { formatMessageWithValues, formatDateFromISO, withHistory, historyPush } from "@openimis/fe-core";
import { fetchHfQualityAssurancies } from "../actions";

class QualityAssuranceDetailSearcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmedAction: "",
    };

    this.rowIdentifier = this.rowIdentifier.bind(this);
    this.rowLocked = this.rowLocked.bind(this);
    this.rowDisabled = this.rowDisabled.bind(this);
    this.headers = this.headers.bind(this);
    this.sorts = this.sorts.bind(this);
    this.itemFormatters = this.itemFormatters.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.submittingMutation && !this.props.submittingMutation && this.props.mutation) {
      this.props.journalize(this.props.mutation);
    } else if (prevProps.confirmed !== this.props.confirmed && this.props.confirmed && this.state.confirmedAction) {
      this.state.confirmedAction();
    }
  }

  rowIdentifier(r) {
    return r.uuid;
  }

  headers(filters) {
    return ["Name", "quality_assurance_and_accreditation.date", "Status", "quality_assurance_and_accreditation.state"];
  }

  sorts(filters) {
    return [
      ["code", true],
      ["name", true],
      ["legalForm", true],
      ["level", true],
      ["careType", true],
      null,
      null,
      null,
      null,
      null,
      ["validityFrom", false],
      ["validityTo", false],
    ];
  }

  itemFormatters(filters) {
    return [
      (acc) => acc.projectName,
      (acc) => formatDateFromISO(this.props.modulesManager, this.props.intl, acc.createdDate),
      (acc) => formatMessage(this.props.intl, "quality_assurance_and_accreditation", `quality_assurance_and_accreditation.status.${acc.status}`),
      (acc) => formatMessage(this.props.intl, "quality_assurance_and_accreditation", `state.${acc.state}`),
    ];
  }

  rowDisabled(selection, i) {
    return !!i.validityTo;
  }

  rowLocked(selection, hf) {
    return !!hf.clientMutationId;
  }

  onDoubleClick = (qa) => {
    const { modulesManager, history } = this.props;
    if (modulesManager && history) {
      historyPush(modulesManager, history, "qa.route.details", [qa.uuid]);
    }
  };

  fetchQualityAssuranceDetails = () => {
    const { projectId } = this.props;
    if (projectId) {
      this.props.fetchHfQualityAssurancies(projectId);
    }
  };
  render() {
    const {
      modulesManager,
      intl,
      healthFacilitiesPageInfo = {
        endCursor: "YXJyYXljb25uZWN0aW9uOjM=",
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: "YXJyYXljb25uZWN0aW9uOjA=",
        totalCount: 5,
      },
      qualityAssuranceDetails,
      fetchedQualityAssuranceDetails,
      fetchingQualityAssuranceDetails,
      errorQualityAssuranceDetails,
      count = 5,
    } = this.props;

    const rowsPerPageOptions = modulesManager.getConf(
      "fe-quality_assurance_and_accreditation",
      "healthFacilityFilter.rowsPerPageOptions",
      [10, 20, 50, 100],
    );
    const defaultPageSize = modulesManager.getConf("fe-quality_assurance_and_accreditation", "healthFacilityFilter.defaultPageSize", 10);

    return (
      <Fragment>
        <Searcher
          module="quality_assurance_and_accreditation"
          rowsPerPageOptions={rowsPerPageOptions}
          defaultPageSize={defaultPageSize}
          fetch={this.fetchQualityAssuranceDetails}
          fetchingItems={fetchingQualityAssuranceDetails}
          fetchedItems={fetchedQualityAssuranceDetails}
          errorItems={errorQualityAssuranceDetails}
          cacheFiltersKey="quality_assurance_and_accreditationSearcher"
          items={qualityAssuranceDetails}
          rowIdentifier={this.rowIdentifier}
          rowLocked={this.rowLocked}
          itemsPageInfo={healthFacilitiesPageInfo}
          FilterPane={AccreditationFilter}
          tableTitle={formatMessageWithValues(intl, "quality_assurance_and_accreditation", "Quality Assurances", { count })}
          headers={this.headers}
          itemFormatters={this.itemFormatters}
          rowDisabled={this.rowDisabled}
          sorts={this.sorts}
          onDoubleClick={this.onDoubleClick}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
  userHealthFacilityFullPath: state.loc.userHealthFacilityFullPath,
  submittingMutation: state.loc.submittingMutation,
  mutation: state.loc.mutation,
  confirmed: state.core.confirmed,
  fetchingQualityAssuranceDetails: state.quality_assurance_and_accreditation.fetchingQualityAssuranceDetails,
  fetchedQualityAssuranceDetails: state.quality_assurance_and_accreditation.fetchedQualityAssuranceDetails,
  qualityAssuranceDetails: state.quality_assurance_and_accreditation.qualityAssuranceDetails,
  errorQualityAssuranceDetails: state.quality_assurance_and_accreditation.errorQualityAssuranceDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ coreConfirm, journalize, fetchHfQualityAssurancies }, dispatch);
};

export default withModulesManager(
  injectIntl(withHistory(connect(mapStateToProps, mapDispatchToProps)(QualityAssuranceDetailSearcher))),
);
